<div class="columns" style="width: 100%">
  <div class="column is-5">
    <label class="label" translationEditableDirective="LATITUDE">{{
      'LATITUDE' | translate
    }}</label>
    <div class="control">
      <number-input
        *ngIf="!isReadonly"
        name="lat"
        (input)="handleLatChange($event.target.value)"
        [value]="lat"
        [inputClass]="{ 'is-danger': !!latError, 'input is-small': true }"
      />
      <span *ngIf="isReadonly">{{ lat }}</span>
    </div>
    <p class="help is-danger" *ngIf="!!latError">
      {{ latError }}
    </p>
  </div>
  <div class="column is-5">
    <label class="label" translationEditableDirective="LONGITUDE">{{
      'LONGITUDE' | translate
    }}</label>
    <div class="control">
      <number-input
        name="lng"
        (input)="handleLngChange($event.target.value)"
        [value]="lng"
        [inputClass]="{ 'is-danger': !!lngError, 'input is-small': true }"
        *ngIf="!isReadonly"
      />
      <span *ngIf="isReadonly">{{ lng }}</span>
    </div>
    <p class="help is-danger" *ngIf="!!lngError">
      {{ lngError }}
    </p>
  </div>
  <div *ngIf="!isReadonly" class="column is-2">
    <lng-lat-picker
      [value]="lng && lat && [lng, lat]"
      (onPick)="handleCoordinatesPick($event)"
    ></lng-lat-picker>
  </div>
</div>
